// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer.sticky-footer{padding:2rem 0;flex-shrink:0}.bg-white{background-color:#fff !important}footer.sticky-footer .copyright{line-height:1;font-size:.8rem;color:#858796;justify-content:center}.footer-link{padding-left:10px;padding-right:10px;min-width:150px}.footer-link a{color:#858796}.footer-link a:hover{text-decoration:none;font-weight:bold}", ""]);
// Exports
module.exports = exports;
